import { createRouter, createWebHistory } from 'vue-router'
import LibraryView from '../views/library-view.vue'

let libraryScroll = { left: 0, top: 0 }

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, _from, saved) {
    return to.path === '/library' ? saved ?? libraryScroll : { left: 0, top: 0 }
  },
  routes: [
    { path: '/', redirect: '/library' },
    { path: '/library', component: LibraryView },
    { path: '/categories', component: () => import('../views/category-management-view.vue') },
    { path: '/collections/:id', component: () => import('../views/collection-view.vue') },
    { path: '/read/local/:comicId', component: () => import('../views/reader-view.vue'), meta: { source: 'local' } },
    { path: '/read/cloud/:comicId', component: () => import('../views/reader-view.vue'), meta: { source: 'cloud' } },
    { path: '/read/collection/:comicId', component: () => import('../views/reader-view.vue'), meta: { source: 'collection' } },
    { path: '/:pathMatch(.*)*', redirect: '/library' },
  ],
})

router.beforeEach((_to, from) => {
  if (from.path === '/library') libraryScroll = { left: window.scrollX, top: window.scrollY }
})
